import {Component, Inject, OnInit} from '@angular/core';
import {IDatasetFileManagerCategoryItems} from '../../../../interface/form-structure';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';

@Component({
    selector: 'noos-file-type-select',
    templateUrl: './file-type-select.component.html',
    styleUrls: ['./file-type-select.component.scss']
})
export class FileTypeSelectComponent implements OnInit {

    constructor(
        private bottomSheetRef: MatBottomSheetRef<FileTypeSelectComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: IDatasetFileManagerCategoryItems[]) {
    }


    ngOnInit() {
    }

    selectFileType(item: IDatasetFileManagerCategoryItems, other: string) {
        this.bottomSheetRef.dismiss(item);
        event.preventDefault();
    }

    onCancel() {
        this.bottomSheetRef.dismiss(undefined);
        event.preventDefault();
    }
}
